// A soft, low-frequency purr generated with the Web Audio API. Two detuned
// square oscillators through a low-pass filter, modulated by a slow LFO,
// give a warm rumble that we ramp up/down as the dog's contentment changes.

let ctx = null;
let masterGain = null;
let running = null; // { stopFns: [], setLevel: (v) => void } | null
let targetLevel = 0;
let currentLevel = 0;
let rafId = null;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
};

const start = () => {
  const audio = getCtx();
  if (!audio) return;
  if (running) return;

  masterGain = audio.createGain();
  masterGain.gain.value = 0;
  masterGain.connect(audio.destination);

  // Low-pass filter to soften the sound
  const lp = audio.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 260;
  lp.Q.value = 4;
  lp.connect(masterGain);

  // Two slightly detuned square oscillators
  const osc1 = audio.createOscillator();
  osc1.type = "square";
  osc1.frequency.value = 44;
  const osc2 = audio.createOscillator();
  osc2.type = "square";
  osc2.frequency.value = 46.5;

  // LFO to modulate amplitude for the "rrrrrr" rumble
  const lfo = audio.createOscillator();
  lfo.type = "sine";
  lfo.frequency.value = 22;
  const lfoGain = audio.createGain();
  lfoGain.gain.value = 0.35;
  const ampMod = audio.createGain();
  ampMod.gain.value = 0.65;
  lfo.connect(lfoGain).connect(ampMod.gain);

  osc1.connect(ampMod);
  osc2.connect(ampMod);
  ampMod.connect(lp);

  osc1.start();
  osc2.start();
  lfo.start();

  running = {
    stopFns: [
      () => {
        try {
          osc1.stop();
        } catch (err) {
          // Oscillator may already be stopped; expected in normal teardown
          console.debug("purr osc1 stop:", err?.message);
        }
        try {
          osc2.stop();
        } catch (err) {
          console.debug("purr osc2 stop:", err?.message);
        }
        try {
          lfo.stop();
        } catch (err) {
          console.debug("purr lfo stop:", err?.message);
        }
      },
    ],
  };
};

const stop = () => {
  if (!running) return;
  running.stopFns.forEach((fn) => fn());
  running = null;
  masterGain = null;
};

const loop = () => {
  const audio = ctx;
  // Ease current level toward target
  currentLevel += (targetLevel - currentLevel) * 0.05;
  if (audio && masterGain) {
    masterGain.gain.setTargetAtTime(currentLevel, audio.currentTime, 0.08);
  }
  if (currentLevel < 0.002 && targetLevel < 0.001) {
    stop();
    rafId = null;
    return;
  }
  rafId = requestAnimationFrame(loop);
};

/** Set purr strength in [0, 1]. Starts / stops audio internally. */
export const setPurrLevel = (level) => {
  const clamped = Math.max(0, Math.min(1, level));
  const gain = clamped * 0.06; // keep it soft
  targetLevel = gain;
  if (gain > 0.001 && !running) start();
  if (rafId == null) rafId = requestAnimationFrame(loop);
};
